<template>
  <div class="kye-report-echarts-bar">
    <slot name="navigation">
      <Navigation
        v-if="code.includes('002') && navigation.length"
        :navigation="navigation">
      </Navigation>
    </slot>
    <div class="kye-report-echarts-bar_dom" ref="echartsBar"></div>
  </div>
</template>

<script>
  import * as echarts from '@kyfe/echarts5'
  import { CreateEchartsConfig, commonProps, extend } from '../common'
  import { echartsType } from '../common/basic/bar'
  import { merge } from 'lodash'
  import Navigation from './navigation.vue'

  export default {
    name: 'kye-form-bar',
    components: {
      Navigation
    },
    props: extend({
      propsConfig: {
        type: Object,
        default: () => ({
          label: 'name',
          value: 'value'
        })
      },
      option: {
        type: Object,
        default: () => ({})
      },
      navigation: {
        type: Array,
        default: () => ([])
      }
    }, commonProps),
    data() {
      return {
        echartsInstance: null,
        echartsConfig: {},
      }
    },
    watch: {
      data(val) {
        // this.renderEcharts()
        if (this.echartsInstance) {
          const valueData = val.map(item => item[this.propsConfig.value])
          const labelData = val.map(item => item[this.propsConfig.label])
          const options = this.echartsInstance.getOption()
          options.series[0].data = valueData
          options.yAxis[0].data = labelData
          this.echartsInstance.setOption(options)
        }
      },
      option() {
        this.renderEcharts()
      }
    },
    mounted() {
      this.renderEcharts()
    },
    methods: {
      renderEcharts() {
        const { autoRender } = this.$props
        if (autoRender) {
          this.init()
        }
      },
      init() {
        this.initEchartsConfig()
        this.initEcharts()
      },
      initEchartsConfig() {
        const { code, data, propsConfig } = this
        this.echartsConfig = new CreateEchartsConfig(echartsType, {
          code,
          data,
          propsConfig
        })
      },
      initEcharts() {
        this.echartsInstance = echarts.init(this.$refs.echartsBar)
        if (this.echartsInstance) {
          const { option } = this.echartsConfig
          this.echartsInstance.setOption(merge(option, this.option), true)
        }
      },
      getEcharts() {
        return this.echartsInstance
      },
      addEchartsEvent(eventName, callBack) {
        if (!eventName || !callBack) return
        this.echartsInstance.on(eventName, callBack)
      }
    },
  }
</script>

<style lang="less">
  @width100: 100%;
  .kye-report-echarts-bar{
    width: @width100;
    height: @width100;
    position: relative;
    display: flex;
    flex-direction: column;
    &_dom{
      flex:1;
      height: @width100;
    }
  }
</style>





// WEBPACK FOOTER //
// src/public/components/kye-report-form/echarts/bar-x/index.vue